import React, { useState } from 'react';
import { useLocale } from 'use-intl';
import { ProductsSlider } from '@/components/ui/sliders';
import Title from '@/components/ui/typography/title';

function RelatedProducts({ isLoading, relatedProducts, title }) {
  const locale = useLocale();

  const [swiper, set_swiper] = useState({});
  const slidesNo = swiper?.slides?.length;
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  return relatedProducts?.length > 0 ? (
    <div className='mb-6'>
      <ProductsSlider
        products={relatedProducts}
        set_swiper={set_swiper}
        locale={locale}
        setIsBeginning={setIsBeginning}
        setIsEnd={setIsEnd}
        isLoading={isLoading}
      >
        <Title
          slidesNo={slidesNo}
          isBeginning={isBeginning}
          isEnd={isEnd}
          showArrows={relatedProducts?.length > 3}
          title={title}
          swiper={swiper}
          locale={locale}
        />
      </ProductsSlider>
    </div>
  ) : null;
}

export default RelatedProducts;
